import React, { useCallback, useContext, useState } from 'react';
import classNames from 'classnames';
import ListingContext from '../../../../providers/Listing/Listing.context';
import { useTranslation } from 'react-i18next';
import usePremiumFeatures from 'hooks/usePremiumFeatures';
import LockopenIcon from 'icons/Lockopen.icon';
import { Button } from 'ncoded-component-library';
import LockclosedIcon from 'icons/Lockclosed.icon';

import './DataRoomIsLockedCard.styles.scss';

type DataRoomIsLockedCardProps = {
  className?: string;
};

const DataRoomIsLockedCard: React.FC<DataRoomIsLockedCardProps> = (props) => {
  const { className } = props;

  const [isLoading, setIsLoading] = useState(false);

  const classes = classNames('data-room-is-locked-card', className);

  const { dealRoom, setDealRoom } = useContext(ListingContext);

  const updateHasPremium = useCallback(
    (hasBossModeUnlockedPremiumFeatures: boolean) =>
      setDealRoom((prev) => ({
        ...prev,
        hasBossModeUnlockedPremiumFeatures,
      })),
    [setDealRoom],
  );

  const { canUnlockPremiumFeatures, updateHasPremiumFeatures } =
    usePremiumFeatures(dealRoom, updateHasPremium, setIsLoading);

  const { t } = useTranslation();

  if (!canUnlockPremiumFeatures) return null;

  return (
    <div className={classes}>
      <p>{t('dataRoomIsLocked')}</p>
      <div className="lock-wrapper">
        <LockclosedIcon />
      </div>
      <Button
        variant="outline"
        icon={LockopenIcon}
        disabled={isLoading}
        onClick={() => updateHasPremiumFeatures(true)}
      >
        {t('unlockAllPremiumFeatures')}
      </Button>
    </div>
  );
};

export default DataRoomIsLockedCard;
